import React from 'react'

import layoutStyles from '../styles/layoutblog.module.scss'

import Header from './headerBlog'
import Contact from './contact'
import Footer from './footer'
import ResponsiveBar from './responsivebar'
import { Link } from "gatsby"

//Cookies
import CookieConsent from 'react-cookie-consent';
import '../styles/cookies.scss'


const Layout = (props) => {

    if (typeof window !== "undefined") {

        require("smooth-scroll")('a[href*="#"]')
      }

    return (
        <div className={layoutStyles.container}>
            <div className={layoutStyles.content}>
                
                <Header />
                <section className={layoutStyles.main}>
                {props.children}
                </section>
                
            </div>
            <Contact />
            <Footer />
            <ResponsiveBar />

            <CookieConsent
                    style={{ background: "rgba(61,65,66,0.95)"}}
                    location="bottom"
                    buttonText="Acepto"
                    declineButtonText="Rechazo"
                    cookieName="gatsby-gdpr-google-analytics"
                    contentClasses="contenidoCookies"
                    buttonClasses="botonesCookies"
                    >
            <h2>Política de Cookies</h2>            
            Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarle publicidad relacionada con sus preferencias mediante el análisis de sus hábitos de navegación. Si continua navegando, consideramos que acepta su uso. <Link to="/politica-cookies" class="vermas">Ver más información</Link>
            </CookieConsent>
        </div>
    )
}

export default Layout
